import { getAllNodesAndEdgesSvc } from './services/getNodesAndEdges';

export type CachedElements = any[];

const cache = new Map<string, CachedElements>();
const timers = new Map<string, ReturnType<typeof setTimeout>>();
const EXP_MS = 3000;

export const makeGraphKey = (navData: any, renderData: any) =>
  renderData?.persistKey ??
  navData?.widgetData?.dataID ??
  navData?.widgetData?.id ??
  navData?.renderID;

const clone = <T>(v: T): T => JSON.parse(JSON.stringify(v));

const scheduleExpiry = (key: string) => {
  const prev = timers.get(key);
  if (prev) clearTimeout(prev);
  const t = setTimeout(() => {
    cache.delete(key);
    timers.delete(key);
  }, EXP_MS);
  timers.set(key, t);
};

export const saveState = (key: string, cy: any): void => {
  (async () => {
    const elements = await getAllNodesAndEdgesSvc(cy);
    cache.set(key, clone(elements));
    scheduleExpiry(key);
  })().catch(() => {});
};

export const getState = (key: string): CachedElements | undefined => {
  const v = cache.get(key);
  return v ? clone(v) : undefined;
};

export const clearState = (key: string): void => {
  cache.delete(key);
  const t = timers.get(key);
  if (t) {
    clearTimeout(t);
    timers.delete(key);
  }
};

export const clearAll = (): void => {
  cache.clear();
  // avoid for..of (needs downlevelIteration); use forEach instead
  timers.forEach((t) => clearTimeout(t));
  timers.clear();
};
